/**
 * Текст ошибки HTTP API для Ant Design message (FastAPI: string | validation[]).
 */
export const formatApiErrorDetail = (error) => {
    const d = error?.response?.data?.detail;
    if (d == null || d === '') {
        if (error?.code === 'ECONNABORTED' || error?.message?.includes?.('timeout')) {
            return 'Превышено время ожидания сервера (синхронизация может занимать несколько минут).';
        }
        return null;
    }
    if (typeof d === 'string') return d;
    if (Array.isArray(d)) {
        return d
            .map((item) => (typeof item === 'object' && item?.msg ? item.msg : String(item)))
            .join('; ');
    }
    if (typeof d === 'object' && d.msg) return String(d.msg);
    return String(d);
};
